import { render } from "./DiscountsBasTemplate.vue?vue&type=template&id=3088cb72"
import script from "./DiscountsBasTemplate.vue?vue&type=script&lang=js"
export * from "./DiscountsBasTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__